import {initializeApp} from 'firebase/app';
import {getFirestore} from 'firebase/firestore';
import { getStorage } from "firebase/storage";

import 'firebase/compat/storage'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA2xqu1XzvDkISlrGVjF55q0tmAwj-MRmw",
  authDomain: "shadablucky-56be1.firebaseapp.com",
  projectId: "shadablucky-56be1",
  storageBucket: "shadablucky-56be1.appspot.com",
  messagingSenderId: "57442050545",
  appId: "1:57442050545:web:262c0857c93d55fdd72450",
  measurementId: "G-32RFJV30S0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig)
const db = getFirestore(app)
export const storage = getStorage(app);
export {db,app};